import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Types for our database tables
export interface ContactFormData {
  id: string
  name: string
  email: string
  company?: string
  message: string
  created_at: string
  source: string
  utm_campaign?: string
  utm_source?: string
  utm_medium?: string
  status: 'new' | 'contacted' | 'qualified' | 'converted'
  consent_given: boolean
  consent_timestamp: string
  ip_address?: string
  user_agent?: string
  referrer?: string
}
